import { render, staticRenderFns } from "./UserMergeModal.vue?vue&type=template&id=f6849a4c"
import script from "./UserMergeModal.vue?vue&type=script&lang=js"
export * from "./UserMergeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports